import React from "react"

import styled from "styled-components"

export default ({ children }) => {
  return <Lede>{children}</Lede>
}

const Lede = styled.p`
  grid-column: 2 / 3;
  margin: 0 0 2rem;
  font-size: 1.25rem;
  text-align: left;
  font-weight: 100;
`
